import { render, staticRenderFns } from "./RecipientProfile.vue?vue&type=template&id=2e91750e&scoped=true&"
import script from "./RecipientProfile.vue?vue&type=script&lang=js&"
export * from "./RecipientProfile.vue?vue&type=script&lang=js&"
import style0 from "./RecipientProfile.vue?vue&type=style&index=0&id=2e91750e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e91750e",
  null
  
)

export default component.exports